import {
    SET_QUANT_NAO_LIDAS
} from './actionTypes'

export function setQuantNaoLidas(quantNaoLidas) {
    return { type: SET_QUANT_NAO_LIDAS, quantNaoLidas }
}
